/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Sei_HelpInputs */



/**
* | output |
* | --- |
* | "In-stream captions need H.264 or HEVC video." |
*
* @param {Embed_Captions_Local_Sei_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_sei_help = /** @type {((inputs?: Embed_Captions_Local_Sei_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Sei_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les sous-titres intégrés nécessitent une vidéo H.264 ou HEVC.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für die Untertitelung im Stream wird H.264- oder HEVC-Video benötigt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per i sottotitoli in tempo reale è necessario il formato video H.264 o HEVC.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для субтитров в видеопотоке требуется видео в формате H.264 или HEVC.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los subtítulos integrados en la transmisión requieren vídeo H.264 o HEVC.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频流内字幕需要 H.264 或 HEVC 视频编码。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画内字幕にはH.264またはHEVC形式の動画が必要です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो स्ट्रीम में कैप्शन दिखाने के लिए H.264 या HEVC वीडियो फॉर्मेट की आवश्यकता होती है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas embutidas no vídeo exigem vídeo em H.264 ou HEVC.")
	return /** @type {LocalizedString} */ ("In-stream captions need H.264 or HEVC video.")
});